module.exports = __webpack_public_path__ + "img/ic24_close@1x.cdbc3c65.svg";